import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RouteEnum } from '@app/constants/route.enum';
import { StringEnum } from '@app/constants/string.enum';

@Component({
  selector: 'app-no-internet',
  imports: [],
  templateUrl: './no-internet.html',
  styleUrl: './no-internet.scss',
})
export class NoInternet {
  protected readonly stringEnum = StringEnum;
  private readonly router = inject(Router);

  protected onTryAgain(): void {
    this.router.navigate([RouteEnum.HOME]);
  }
}
